import React, {useEffect, useState} from 'react';
import Modal from 'react-bootstrap/Modal';
import {Trans} from 'react-i18next';
import frontendUtils from '../../../utils/frontendUtils';
import ContactUsFormModal from './ContactUsFormModal';

export default function PartnerAuthModal({auth}) {
  const [show, setShow] = useState(false);
  const [showForm, setShowForm] = useState(false);

  useEffect(() => setShow(auth.customer.applicationStatus !== 'APPROVED'), [
    auth,
  ]);

  const partnerStatus = auth.customer.applicationStatus;
  const showForever = !partnerStatus || partnerStatus === 'REJECTED';
  return (
    <Modal
      dialogClassName="app-auth-modal"
      show={showForever || show}
      onHide={() => {
        if (showForever) {
          return;
        }
        window.location.href = frontendUtils.getPartnerUrl('app-auth');
      }}
    >
      <Modal.Header closeButton={!showForever}>
        <Modal.Title>
          {(() => {
            if (partnerStatus === 'SUBMITTED')
              return (
                <Trans i18nKey="partner.status.submitted.title">
                  Your application is being processed
                </Trans>
              );
            else if (partnerStatus === 'REJECTED')
              return (
                <Trans i18nKey="partner.status.rejected.title">
                  Your application was not approved
                </Trans>
              );
            else
              return (
                <Trans i18nKey="partner.status.account.not.exist.title">
                  Account does not exist
                </Trans>
              );
          })()}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          {(() => {
            if (partnerStatus === 'SUBMITTED')
              return (
                <Trans i18nKey="partner.status.submitted.desc">
                  Your application has been received and will be processed by us
                  within five business days. Once your application has been
                  approved, you will be granted to access this partner portal.{' '}
                  <a
                    href={frontendUtils.getPartnerUrl('app-auth')}
                    className="kt-link"
                  >
                    Back to the website
                  </a>
                  .
                </Trans>
              );
            else if (partnerStatus === 'REJECTED')
              return (
                <Trans i18nKey="partner.status.rejected.desc">
                  Unfortunately, your application to the PERFECT Partner Program
                  was not approved. If you have any problem, please{' '}
                  <a
                    href="javascript:;"
                    className="kt-link"
                    onClick={() => setShowForm(true)}
                  >
                    contact us
                  </a>
                  .
                </Trans>
              );
            else
              return (
                <Trans i18nKey="partner.status.account.not.exist.desc">
                  Account does not exist. Please register an{' '}
                  <a
                    href={frontendUtils.getPartnerUrl('app-auth')}
                    className="kt-link"
                  >
                    partner account
                  </a>{' '}
                  first.
                </Trans>
              );
          })()}
        </div>
        <ContactUsFormModal showForm={showForm} setShowForm={setShowForm} />
      </Modal.Body>
    </Modal>
  );
}
